export default "__VITE_ASSET__3d293663__"